import React from 'react';
import { Container, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <div>
      <Container>
        <Col className='text-center py-3'>Copyright &copy; Elektronix Shop</Col>
      </Container>
    </div>
  );
};

export default Footer;
